export default __webpack_public_path__ + "static/media/logo_yego.23375cdf.png";